import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClipboard2Sparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconClipboard2Sparkle"><Path d="M16.5 4.5H20.5V11.5M7.5 4.5H3.5V21.5H13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 2.5H16.5V6.5H7.5V2.5Z" stroke="currentColor"/><Path d="M18.4 14H17.6L16.6 16.6L14 17.6V18.4L16.6 19.4L17.6 22H18.4L19.4 19.4L22 18.4V17.6L19.4 16.6L18.4 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClipboard2Sparkle;
